var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TimelineComponent',{attrs:{"dailyBasis":true,"captainId":2}})
}
var staticRenderFns = []

export { render, staticRenderFns }